var React = require('react');

function WrongFacebookLogoInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Facebook"),React.createElement("path",{"d":"m2.28125 5.41667h-2.03125v2.70833h2.03125v8.125h3.38542v-8.125h2.46593l.2424-2.70833h-2.70833v-1.1287c0-.64662.13-.90255.75494-.90255h1.95339v-3.38542h-2.57833c-2.43479 0-3.51542 1.07182-3.51542 3.12474z","key":1})]);
}

WrongFacebookLogoInline.defaultProps = {"height":"17","viewBox":"0 0 9 17","width":"9"};

module.exports = WrongFacebookLogoInline;

WrongFacebookLogoInline.default = WrongFacebookLogoInline;
